import { EProductType } from "./EProductType";

export const ECompanyAgreements = {
  DIRECT_DEPOSIT: "direct_deposit_form",
  DEPOSIT_ACCOUNT: "deposit_account_form",
  ELECTRONIC_COMMUNICATION: "electronic_communication_form",
  PATRIOT_ACT: "patriot_act_form",
  PUZZL_TERMS_CONDITIONS: "puzzl_terms_conditions",
  REPORTING_AGENT: "reporting_agent_form",
  TAX_INFORMATION_AUTHORIZATION: "tax_information_authorization_form",
} as const;

export type TCompanyAgreement =
  (typeof ECompanyAgreements)[keyof typeof ECompanyAgreements];

export const CompanyAgreementProductTypes: Record<
  TCompanyAgreement,
  EProductType[]
> = {
  [ECompanyAgreements.DIRECT_DEPOSIT]: [EProductType.PAYROLL],
  [ECompanyAgreements.DEPOSIT_ACCOUNT]: [EProductType.PAYROLL],
  [ECompanyAgreements.ELECTRONIC_COMMUNICATION]: [
    EProductType.ONBOARDING_ONLY,
    EProductType.PAYROLL,
  ],
  [ECompanyAgreements.PATRIOT_ACT]: [
    EProductType.ONBOARDING_ONLY,
    EProductType.PAYROLL,
  ],
  [ECompanyAgreements.PUZZL_TERMS_CONDITIONS]: [
    EProductType.ONBOARDING_ONLY,
    EProductType.PAYROLL,
  ],
  [ECompanyAgreements.REPORTING_AGENT]: [EProductType.PAYROLL],
  [ECompanyAgreements.TAX_INFORMATION_AUTHORIZATION]: [EProductType.PAYROLL],
} as const;
